import html2canvas from "html2canvas";
import api from "@/lib/api";

// Flattens a designer stage into a PNG proof and uploads it to storage.
export async function captureProof(node, name = "proof", bg = "#0b0b0d") {
    if (!node) return null;
    const canvas = await html2canvas(node, { backgroundColor: bg, scale: 2, useCORS: true, logging: false });
    const blob = await new Promise((res) => canvas.toBlob(res, "image/png"));
    if (!blob) return null;
    const fd = new FormData();
    fd.append("file", new File([blob], `${name}.png`, { type: "image/png" }));
    const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
    return data;
}
